/*
Header
*/

import React, { useState, useRef } from "react";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import DropdownMenu from "./dropdown-menu";

// import logo from "../../images/logo.png";
// import logo from "../../images/logo-yell.png";
import logo from "../../images/logo-roch.svg";

const Header = ({ headerLinks, isIndexPage }) => {
  const [collapsed, setCollapsed] = useState(true);

  let navbarClassName = "collapse navbar-collapse";
  let navbarBrandClassname = "d-flex align-items-center navbar-brand-container";
  if (!collapsed) {
    navbarClassName += " show expanded";
    navbarBrandClassname += " navbar-brand-container-dropdown-expanded";
  }

  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg fixed-top shadow navbar-light bg-white">
        <div className="container-fluid">
          <div className={navbarBrandClassname}>
            <Link to="/" className="navbar-brand ">
              <img src={logo} alt="Directory logo" />
            </Link>
          </div>

          <button
            type="button"
            data-toggle="collapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
            className="navbar-toggler navbar-toggler-right"
            onClick={() => {
              setCollapsed(!collapsed);
            }}
          >
            <FontAwesomeIcon icon={faBars} className="" fixedWidth size="sm" />
          </button>

          <div className={navbarClassName}>
            <DropdownMenu headerLinks={headerLinks} isIndexPage={isIndexPage} />
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
